var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC4D",
    transform: "rotate(180 6 6)",
    d: "M0.734894472,0.0044 C0.102994975,0.0044 -0.175567839,0.4728 0.115356784,1.0452 L5.4699799,11.5670154 C5.76087437,12.1394154 6.23770854,12.1394154 6.52896482,11.5670154 L11.8836181,1.0452 C12.175206,0.4728 11.8963116,0.0044 11.2640804,0.0044 L0.734894472,0.0044 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    transform: "rotate(180 6 6)",
    d: "M5.23643511,8.52547692 C5.23643511,8.98129231 5.57702457,9.26344615 6.02747857,9.26344615 C6.46731057,9.26344615 6.81889583,8.97076923 6.81889583,8.52547692 L6.81889583,4.34615385 C6.81889583,3.9012 6.46731057,3.60818462 6.02747857,3.60818462 C5.57702457,3.60818462 5.23643511,3.89070769 5.23643511,4.34615385 L5.23643511,8.52547692 Z M5.17052261,2.12135385 C5.17052261,2.58803077 5.55506412,2.96784615 6.02747857,2.96784615 C6.49992418,2.96784615 6.88480833,2.588 6.88480833,2.12135385 C6.88480833,1.65433846 6.49992418,1.27449231 6.02747857,1.27449231 C5.55506412,1.27449231 5.17052261,1.65433846 5.17052261,2.12135385 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.c94ec5c6b659f2b15b7d5f718fb31dbe.svg";
export { ForwardRef as ReactComponent };